import { render, staticRenderFns } from "./SectionBegin.vue?vue&type=template&id=062489e4&"
import script from "./SectionBegin.vue?vue&type=script&lang=js&"
export * from "./SectionBegin.vue?vue&type=script&lang=js&"
import style0 from "./SectionBegin.vue?vue&type=style&index=0&id=062489e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports